<template>
  <div>
    <div v-show="!ready" class="spinner large light center"></div>
    <Editor
      v-show="ready && $attrs.html !== null"
      v-if="$attrs.html !== null"
      v-bind="$attrs"
      @ready="ready = true"
      @save="$emit('save', $event)"
      @cancel="$emit('cancel', $event)"
    ></Editor>
  </div>
</template>

<script>
import Editor from "@/components/singles/Editor.vue";
export default {
  components: { Editor },
  data() {
    return { ready: false };
  }
};
</script>
